import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import {
  ConfirmRemoveRecognition as ConfirmRemoveRecognitionBase,
  ConfirmArchiveRecognition as ConfirmArchiveRecognitionBase,
  ConfirmRemoveScheduledRecognition as ConfirmRemoveScheduledRecognitionBase
} from "./Confirm"

const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
`

const styles = `
  position: absolute;
  top: 0;
  right: 0;
  margin-top: ${padding.base};
  text-align: left;
  z-index: 10;
`

const ConfirmRemoveRecognition = styled(ConfirmRemoveRecognitionBase)`
  ${styles}
`
const ConfirmRemoveScheduledRecognition = styled(ConfirmRemoveScheduledRecognitionBase)`
  ${styles}
  right: unset;
  left: 0;
`
const ConfirmArchiveRecognition = styled(ConfirmArchiveRecognitionBase)`
  ${styles}
`

export {ActionsWrapper, ConfirmRemoveRecognition, ConfirmArchiveRecognition, ConfirmRemoveScheduledRecognition}
